import { fetchAndActivate, getValue } from 'firebase/remote-config';
import type { RemoteConfig } from 'firebase/remote-config';
import type { BlockConfig } from '../../domain/entities/block-config.entity';

const REMOTE_CONFIG_KEY = 'block_aristo_dashboards';

const DEFAULT_BLOCK_CONFIG: BlockConfig = {
  blocked: false,
  allowedEmails: [],
};

export class RemoteConfigDatasource {
  private readonly remoteConfig: RemoteConfig;

  constructor(remoteConfig: RemoteConfig) {
    this.remoteConfig = remoteConfig;
  }

  async getBlockConfig(): Promise<BlockConfig> {
    await fetchAndActivate(this.remoteConfig);
    const raw = getValue(this.remoteConfig, REMOTE_CONFIG_KEY).asString();
    if (!raw) return DEFAULT_BLOCK_CONFIG;
    try {
      return JSON.parse(raw) as BlockConfig;
    } catch {
      return DEFAULT_BLOCK_CONFIG;
    }
  }
}
